import React  from 'react';

export default function renderStoryPointsGroupListHeader(props) {
    const classes = Classes(props.className, 'gd-field-list-group-list-header');

    return (
        <div className={classes}>
            <div className="group-list-header-value">{props.data.label ? props.data.label : "Not selected"}</div>
        </div>
    );
}